<template>
  <div class="trial-used-overlay" @click.self="$emit('close')">
    <div class="trial-used-modal" role="dialog" aria-modal="true" aria-labelledby="trial-modal-title">
      <div class="trial-modal-header">
        <h2 id="trial-modal-title">無料トライアルは<br>すでにご利用済みです</h2>
        <button class="trial-modal-close" aria-label="閉じる" @click="$emit('close')">×</button>
      </div>

      <div v-html="PremiumTrialFlg2Exp"></div>

      <div class="trial-modal-footer">
        <button class="trial-btn-register" @click="$emit('confirm')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
          プレミアムに登録する
        </button>
        <button class="trial-btn-close-text" @click="$emit('close')">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    PremiumTrialFlg2Exp () {
      return this.$store.getters.getUser.premiumTrialFlg2Exp
    }
  }
}
</script>

<style scoped>
.trial-used-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  overflow-y: auto;
  padding: 20px;
}

.trial-used-modal {
  background: #fff;
  border-radius: 12px;
  width: 420px;
  max-width: 95%;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

.trial-modal-header {
  background: #3498db;
  border-bottom: 2px solid #f5a623;
  padding: 18px 20px 14px;
  position: relative;
  text-align: center;
}

.trial-modal-header h2 {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.4;
}

.trial-modal-close {
  position: absolute;
  top: 12px;
  right: 14px;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  line-height: 1;
  padding: 2px 6px;
  border-radius: 4px;
  transition: color 0.15s, background 0.15s;
}
.trial-modal-close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
}

.trial-modal-footer {
  padding: 12px 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.trial-btn-register {
  width: 100%;
  background: #f5a623;
  border: none;
  border-radius: 8px;
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.15s, transform 0.1s;
}
.trial-btn-register:hover { background: #e09510; }
.trial-btn-register:active { transform: scale(0.98); }

.trial-btn-close-text {
  background: none;
  border: none;
  font-size: 13px;
  color: #999;
  cursor: pointer;
  text-decoration: underline;
  padding: 2px;
}
.trial-btn-close-text:hover { color: #555; }
</style>



// WEBPACK FOOTER //
// src/view/setting/TrialUsedModal.vue